<template>
  <div id="kakutei-wrapper">
    <h2 class="title">確定申告報酬 簡易計算フォーム</h2>

    <div class="half-style left">
      <h3>１．確定申告報酬</h3>
    </div>

    <div class="half-style left">
      <h4>事業所得</h4>
    </div>

    <div class="half-style left sub-content">
      <div class="label-style">事業所得区分</div>
      <div>
        <md-radio name="zigyoSyotokuKbn" v-model="zigyoSyotokuKbn" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="zigyoSyotokuKbn" v-model="zigyoSyotokuKbn" md-value="営業等" class="md-primary">営業等
        </md-radio>
        <md-radio name="zigyoSyotokuKbn" v-model="zigyoSyotokuKbn" md-value="農業" class="md-primary">農業
        </md-radio>
      </div>
    </div>

    <div class="half-style left sub-content" v-show="zigyoSyotokuKbn !== '無'">
      <div class="label-style">申告種類</div>
      <div>
        <md-radio name="shinkokuKbn" v-model="zigyoShinkokuKbn" md-value="白色申告" class="md-primary">白色申告
        </md-radio>
        <md-radio name="shinkokuKbn" v-model="zigyoShinkokuKbn" md-value="青色申告(簡易帳簿)" class="md-primary">
          青色申告(簡易帳簿)
        </md-radio>
        <md-radio name="shinkokuKbn" v-model="zigyoShinkokuKbn" md-value="青色申告(65万円控除)" class="md-primary">
          青色申告(65万円控除)
        </md-radio>
      </div>
    </div>

    <md-input-container class="half-style sub-content" v-show="zigyoSyotokuKbn !== '無'">
      <label>前年売上高</label>
      <md-input v-model="zigyoZenUri" class="right" @input.native="validateNumber($event)"
                @focus="manageComma('zigyoZenUri', true)" @blur="manageComma('zigyoZenUri', false)"/>
      <span class="unit">円</span>
    </md-input-container>
    <md-input-container class="half-style sub-content" v-show="zigyoSyotokuKbn !== '無'">
      <label>前々年売上高</label>
      <md-input v-model="zigyoZenZenUri" class="right" @input.native="validateNumber($event)"
                @focus="manageComma('zigyoZenZenUri', true)" @blur="manageComma('zigyoZenZenUri', false)"/>
      <span class="unit">円</span>
    </md-input-container>

    <div class="half-style left">
      <h4>不動産所得</h4>
    </div>

    <div class="half-style left sub-content">
      <div class="label-style">不動産所得区分</div>
      <div>
        <md-radio name="fudoSyotokuKbn" v-model="fudoSyotokuKbn" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="fudoSyotokuKbn" v-model="fudoSyotokuKbn" md-value="一括借上不動産" class="md-primary">一括借上不動産
        </md-radio>
        <md-radio name="fudoSyotokuKbn" v-model="fudoSyotokuKbn" md-value="自己管理不動産" class="md-primary">自己管理不動産
        </md-radio>
      </div>
    </div>

    <div class="half-style left sub-content" v-show="fudoSyotokuKbn !== '無'">
      <div class="label-style">申告種類</div>
      <div>
        <md-radio name="shinkokuKbn" v-model="fudoShinkokuKbn" md-value="白色申告" class="md-primary">白色申告
        </md-radio>
        <md-radio name="shinkokuKbn" v-model="fudoShinkokuKbn" md-value="青色申告(簡易帳簿)" class="md-primary">
          青色申告(簡易帳簿)
        </md-radio>
        <md-radio name="shinkokuKbn" v-model="fudoShinkokuKbn" md-value="青色申告(65万円控除)" class="md-primary">
          青色申告(65万円控除)
        </md-radio>
      </div>
    </div>

    <md-input-container class="half-style sub-content" v-show="fudoSyotokuKbn !== '無'">
      <label>所得金額</label>
      <md-input v-model="fudoUriage" class="right" @input.native="validateNumber($event)"
                @focus="manageComma('fudoUriage', true)" @blur="manageComma('fudoUriage', false)"/>
      <span class="unit">円</span>
    </md-input-container>
    <md-input-container class="half-style sub-content" v-show="fudoSyotokuKbn !== '無'">
      <label>控除前所得</label>
      <md-input v-model="fudokojomaeSyotoku" class="right" @input.native="validateNumber($event)"
                @focus="manageComma('fudokojomaeSyotoku', true)" @blur="manageComma('fudokojomaeSyotoku', false)"/>
      <span class="unit">円</span>
    </md-input-container>

    <div class="half-style left sub-content" v-show="fudoSyotokuKbn !== '無'">
      <div class="label-style">共有者</div>
      <div>
        <md-radio name="fudoSyotokuKbn" v-model="fudoKyoyuSya" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="fudoSyotokuKbn" v-model="fudoKyoyuSya" md-value="有" class="md-primary">有</md-radio>
      </div>
    </div>

    <md-input-container class="half-style sub-content" v-show="fudoSyotokuKbn !== '無' && fudoKyoyuSya !== '無'">
      <label>共有人数</label>
      <md-input v-model="fudoKyoyuSyaSu" class="right" @input.native="validateNumber($event)"
                @focus="manageComma('fudoKyoyuSyaSu', true)" @blur="manageComma('fudoKyoyuSyaSu', false)"/>
      <span class="unit">人</span>
    </md-input-container>

    <div class="half-style left">
      <h4>給与所得</h4>
    </div>
    <div class="half-style left sub-content">
      <div class="label-style">給与所得区分</div>
      <div>
        <md-radio name="kyuyoSyotokuKbn" v-model="kyuyoSyotokuKbn" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="kyuyoSyotokuKbn" v-model="kyuyoSyotokuKbn" md-value="1カ所" class="md-primary">1カ所
        </md-radio>
        <md-radio name="kyuyoSyotokuKbn" v-model="kyuyoSyotokuKbn" md-value="2カ所以上" class="md-primary">2カ所以上
        </md-radio>
      </div>
    </div>

    <div class="half-style left">
      <h4>雑所得</h4>
    </div>
    <div class="half-style left sub-content">
      <div class="label-style">雑所得区分</div>
      <div>
        <md-radio name="zatsuSyotokuKbn" v-model="zatsuSyotokuKbn" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="zatsuSyotokuKbn" v-model="zatsuSyotokuKbn" md-value="公的年金等" class="md-primary">公的年金等
        </md-radio>
        <md-radio name="zatsuSyotokuKbn" v-model="zatsuSyotokuKbn" md-value="その他の雑所得" class="md-primary">その他の雑所得
        </md-radio>
      </div>
    </div>

    <div class="half-style left">
      <h4>譲渡所得</h4>
    </div>
    <div class="half-style left sub-content">
      <div class="label-style">譲渡所得区分</div>
      <div>
        <md-radio name="jotoSyotokuKbn" v-model="jotoSyotokuKbn" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="jotoSyotokuKbn" v-model="jotoSyotokuKbn" md-value="有" class="md-primary">有</md-radio>
      </div>
    </div>

    <md-input-container class="half-style sub-content" v-show="jotoSyotokuKbn !== '無'">
      <label>土地</label>
      <md-input v-model="jotoTochiSu" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">件</span>
    </md-input-container>

    <div class="half-style left sub-content" v-show="jotoSyotokuKbn !== '無' && Number(jotoTochiSu) > 0">
      <div class="label-style">土地取得費</div>
      <div>
        <md-radio name="jotoTochiKbn" v-model="jotoTochiKbn" md-value="購入時の領収証等有り" class="md-primary">
          購入時の領収証等有り
        </md-radio>
        <md-radio name="jotoTochiKbn" v-model="jotoTochiKbn" md-value="取得費不明(5%)" class="md-primary">取得費不明(5%)
        </md-radio>
        <md-radio name="jotoTochiKbn" v-model="jotoTochiKbn" md-value="オプション調査" class="md-primary">オプション調査
        </md-radio>
      </div>
    </div>

    <md-input-container class="half-style sub-content" v-show="jotoSyotokuKbn !== '無'">
      <label>建物</label>
      <md-input v-model="jotoTatemonoSu" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">件</span>
    </md-input-container>

    <div class="half-style left sub-content" v-show="jotoSyotokuKbn !== '無' && Number(jotoTatemonoSu) > 0">
      <div class="label-style">建物取得費</div>
      <div>
        <md-radio name="jotoTochiKbn" v-model="jotoTatemonoKbn" md-value="購入時の領収証等有り" class="md-primary">
          購入時の領収証等有り
        </md-radio>
        <md-radio name="jotoTochiKbn" v-model="jotoTatemonoKbn" md-value="取得費不明(5%)" class="md-primary">
          取得費不明(5%)
        </md-radio>
        <md-radio name="jotoTochiKbn" v-model="jotoTatemonoKbn" md-value="オプション調査" class="md-primary">オプション調査
        </md-radio>
      </div>
    </div>

    <md-input-container class="half-style sub-content" v-show="jotoSyotokuKbn !== '無'">
      <label>動産</label>
      <md-input v-model="jotoDousanSu" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">件</span>
    </md-input-container>


    <div class="half-style left">
      <h4>その他所得</h4>
    </div>
    <div class="half-style left sub-content">
      <div class="label-style">その他所得区分</div>
      <div>
        <md-radio name="sonotaSyotokuKbn" v-model="sonotaSyotokuKbn" md-value="無" class="md-primary">無
        </md-radio>
        <md-radio name="sonotaSyotokuKbn" v-model="sonotaSyotokuKbn" md-value="一時所得" class="md-primary">一時所得
        </md-radio>
        <md-radio name="sonotaSyotokuKbn" v-model="sonotaSyotokuKbn" md-value="山林所得" class="md-primary">山林所得
        </md-radio>
        <md-radio name="sonotaSyotokuKbn" v-model="sonotaSyotokuKbn" md-value="退職所得" class="md-primary">退職所得
        </md-radio>
        <md-radio name="sonotaSyotokuKbn" v-model="sonotaSyotokuKbn" md-value="配当所得" class="md-primary">配当所得
        </md-radio>
        <md-radio name="sonotaSyotokuKbn" v-model="sonotaSyotokuKbn" md-value="利子所得" class="md-primary">利子所得
        </md-radio>
      </div>
    </div>

    <div class="half-style left">
      <h3>２．所得控除</h3>
    </div>

    <div class="half-style left sub-content">
      <div class="label-style">雑損控除</div>
      <div>
        <md-radio name="zassonkojo" v-model="zassonkojo" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="zassonkojo" v-model="zassonkojo" md-value="災害" class="md-primary">災害</md-radio>
        <md-radio name="zassonkojo" v-model="zassonkojo" md-value="盗難" class="md-primary">盗難</md-radio>
        <md-radio name="zassonkojo" v-model="zassonkojo" md-value="横領" class="md-primary">横領</md-radio>
      </div>
    </div>

    <div class="half-style left sub-content">
      <div class="label-style">医療費控除</div>
      <div>
        <md-radio name="iryouhikojo" v-model="iryouhikojo" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="iryouhikojo" v-model="iryouhikojo" md-value="有" class="md-primary">有</md-radio>
      </div>
    </div>

    <div class="half-style left sub-content">
      <div class="label-style">小規模企業共済控除</div>
      <div>
        <md-radio name="syokiboKyosaikojo" v-model="syokiboKyosaikojo" md-value="無" class="md-primary">無
        </md-radio>
        <md-radio name="syokiboKyosaikojo" v-model="syokiboKyosaikojo"
                  md-value="小規模企業共済掛金" class="md-primary">小規模企業共済掛金
        </md-radio>
        <md-radio name="syokiboKyosaikojo" v-model="syokiboKyosaikojo"
                  md-value="確定拠出年金の掛金" class="md-primary">確定拠出年金の掛金
        </md-radio>
        <md-radio name="syokiboKyosaikojo" v-model="syokiboKyosaikojo"
                  md-value="心身障害者扶養共済制度の掛金" class="md-primary">心身障害者扶養共済制度の掛金
        </md-radio>
      </div>
    </div>

    <div class="half-style left sub-content">
      <div class="label-style">寄附金控除</div>
      <div>
        <md-radio name="kifukinkojo" v-model="kifukinkojo" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="kifukinkojo" v-model="kifukinkojo" md-value="有" class="md-primary">有</md-radio>
      </div>
    </div>

    <div class="half-style left sub-content">
      <div class="label-style">寡婦(夫)控除</div>
      <div>
        <md-radio name="kahukojo" v-model="kahukojo" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="kahukojo" v-model="kahukojo" md-value="有" class="md-primary">有</md-radio>
      </div>
    </div>

    <div class="half-style left sub-content">
      <div class="label-style">配偶者控除</div>
      <div>
        <md-radio name="haigusyakojo" v-model="haigusyakojo" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="haigusyakojo" v-model="haigusyakojo" md-value="38万円以下" class="md-primary">38万円以下
        </md-radio>
        <md-radio name="haigusyakojo" v-model="haigusyakojo" md-value="38万円超76万円以下" class="md-primary">
          38万円超76万円以下
        </md-radio>
      </div>
    </div>

    <div class="half-style left">
      <h3>３．その他</h3>
    </div>

    <div class="half-style left sub-content">
      <div class="label-style">住宅ローン控除</div>
      <div>
        <md-radio name="jutakuLoankojo" v-model="jutakuLoankojo" md-value="無" class="md-primary">無
        </md-radio>
        <md-radio name="jutakuLoankojo" v-model="jutakuLoankojo" md-value="住宅ローン控除(初年度)" class="md-primary">
          住宅ローン控除(初年度)
        </md-radio>
        <md-radio name="jutakuLoankojo" v-model="jutakuLoankojo" md-value="バリアフリー税額控除" class="md-primary">
          バリアフリー税額控除
        </md-radio>
        <md-radio name="jutakuLoankojo" v-model="jutakuLoankojo" md-value="その他住宅減税" class="md-primary">その他住宅減税
        </md-radio>
      </div>
    </div>

    <div class="half-style left sub-content">
      <div class="label-style">株式損失繰越控除</div>
      <div>
        <md-radio name="kabuSonkojo" v-model="kabuSonkojo" md-value="無" class="md-primary">無
        </md-radio>
        <md-radio name="kabuSonkojo" v-model="kabuSonkojo" md-value="譲渡損失の繰越控除" class="md-primary">譲渡損失の繰越控除
        </md-radio>
        <md-radio name="kabuSonkojo" v-model="kabuSonkojo" md-value="譲渡損失の損益通算" class="md-primary">譲渡損失の損益通算
        </md-radio>
      </div>
    </div>

    <div class="half-style left">
      <h3>４．贈与税申告</h3>
    </div>

    <div class="half-style left sub-content">
      <div class="label-style">贈与形態</div>
      <div>
        <md-radio name="zoyoKeitai" v-model="zoyoKeitai" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="zoyoKeitai" v-model="zoyoKeitai" md-value="通常贈与" class="md-primary">通常贈与</md-radio>
        <md-radio name="zoyoKeitai" v-model="zoyoKeitai" md-value="相続時精算課税" class="md-primary">相続時精算課税</md-radio>
      </div>
    </div>

    <md-input-container class="half-style sub-content" v-show="zoyoKeitai !== '無'">
      <label>土地</label>
      <md-input v-model="zoyoTochiSu" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">件</span>
    </md-input-container>

    <div class="half-style left sub-content" v-show="zoyoKeitai !== '無' && Number(zoyoTochiSu) > 0">
      <div class="label-style">評価方法</div>
      <div>
        <md-radio name="zoyoTochiHyoka" v-model="zoyoTochiHyoka" md-value="倍率評価" class="md-primary">
          倍率評価
        </md-radio>
        <md-radio name="zoyoTochiHyoka" v-model="zoyoTochiHyoka" md-value="路線価" class="md-primary">路線価
        </md-radio>
      </div>
    </div>

    <md-input-container class="half-style sub-content" v-show="zoyoKeitai !== '無'">
      <label>建物</label>
      <md-input v-model="zoyoTatemonoSu" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">件</span>
    </md-input-container>

    <md-input-container class="half-style sub-content" v-show="zoyoKeitai !== '無'">
      <label>動産</label>
      <md-input v-model="zoyoDousanSu" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">件</span>
    </md-input-container>

    <div class="half-style left sub-content" v-show="zoyoKeitai !== '無'">
      <div class="label-style">特例</div>
      <div>
        <md-radio name="zoyoKeitai" v-model="zoyoTokurei" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="zoyoKeitai" v-model="zoyoTokurei" md-value="配偶者控除" class="md-primary">配偶者控除</md-radio>
        <md-radio name="zoyoKeitai" v-model="zoyoTokurei" md-value="住宅取得等資金" class="md-primary">住宅取得等資金</md-radio>
        <md-radio name="zoyoKeitai" v-model="zoyoTokurei" md-value="納税猶予(農地)" class="md-primary">納税猶予(農地)</md-radio>
        <md-radio name="zoyoKeitai" v-model="zoyoTokurei" md-value="納税猶予(株式)" class="md-primary">納税猶予(株式)</md-radio>
      </div>
    </div>

    <div id="shiharai-sogaku">
      <div class="small-text" v-if="mitsumoriFuka === '不可'">売上が1000万円を超えているため、<br>見積できません。</div>
      <div class="mid-text" v-if="mitsumoriFuka !== '不可'">確定申告報酬</div>
      <template v-if="mitsumoriFuka !== '不可'">{{mitsumoriSyokei.toLocaleString() + ' 円'}}</template>
      <span class="mid-text" v-if="mitsumoriFuka !== '不可'">(税抜)</span>
    </div>
    <div v-if="mitsumoriFuka === '不可'" class="warn-text">年間報酬簡易計算フォームをご利用ください。</div>

    <md-button class="mitsumori-button md-raised md-primary" v-show="!isShowing" @click="toggleShow">
      御見積書表示
    </md-button>
    <md-button class="mitsumori-button md-raised md-primary" v-show="isShowing" @click="toggleShow">
      御見積書非表示
    </md-button>

    <div v-show="isShowing" id="mitsumori-syo-wrapper">
      <div id="mitsumori-syo">
        <div id="mitsumori-title">御見積書</div>
        <div id="mitsumori-client-wrapper">
          <div id="mitsumori-client">
            <span id="mitsumori-name">納税者</span>
            <span id="mitsumori-sama">様</span>
          </div>
        </div>
        <div id="mitsumori-contact-wrapper">
          <div id="mitsumori-contact">
            〒355-0027<br>
            埼玉県東松山市美土里町6-67<br>
            服部税理士事務所<br>
            TEL 0493-81-6162<br>
            FAX 0493-81-6163<br>
          </div>
        </div>
        <div id="mitsumori-cost-wrapeer">
          下記の通りお見積もり申し上げます。
          <table id="mitsumori-cost-table" cellspacing="0">
            <tr>
              <td id="mitsumori-cost-title">お見積もり金額 <br>（消費税込）</td>
              <td id="mitsumori-cost">{{mitsumoriFuka !== '不可' ? mitsumoriGokei.toLocaleString() + ' 円' : '見積不可'}}</td>
            </tr>
          </table>
          <div v-if="mitsumoriFuka === '不可'" class="warn-text">年間報酬簡易計算フォームをご利用ください。</div>
        </div>
        <div class="left">見積明細</div>
        <table id="mitsumori-table" cellspacing="0">
          <tr>
            <th>内容</th>
            <th>数量</th>
            <th>単位</th>
            <th>単価</th>
            <th>金額</th>
          </tr>
          <tr>
            <td>確定申告基本報酬</td>
            <td class="right">1</td>
            <td>件</td>
            <td class="right">{{zigyoSyotokuKbn === '無' && fudoSyotokuKbn === '無' ? '10,000' :
              zigyoKihonHosyu.toLocaleString()}}
            </td>
            <td class="right">{{zigyoSyotokuKbn === '無' && fudoSyotokuKbn === '無' ? '10,000' :
              zigyoKihonHosyu.toLocaleString()}}
            </td>
          </tr>
          <tr>
            <td>{{mitsumoriNaiyou2_1 + mitsumoriNaiyou2_2}}</td>
            <td class="right">{{mitsumoriSuryo2}}</td>
            <td>件</td>
            <td class="right"></td>
            <td class="right">{{mitsumoriKingaku2.toLocaleString()}}</td>
          </tr>
          <tr v-if="jotoSyotokuKbn === '有'">
            <td v-html="mitsumoriNaiyou3"></td>
            <td class="right">{{asNum(jotoTochiSu) + asNum(jotoTatemonoSu) + asNum(jotoDousanSu)}}</td>
            <td>件</td>
            <td class="right"></td>
            <td class="right">{{jotoHosyuGokei + sonotaHosyuGokei}}</td>
          </tr>
          <tr v-if="kojoHosyuGokei !== 0">
            <td>所得控除・税額控除</td>
            <td class="right">1</td>
            <td>件</td>
            <td class="right">{{kojoHosyuGokei}}</td>
            <td class="right">{{kojoHosyuGokei}}</td>
          </tr>
          <tr v-if="zoyoKeitai !== '無'">
            <td>{{zoyoKeitai === '相続時精算課税' ? '贈与税申告（相続時精算課税）' : '贈与税申告'}}</td>
            <td class="right">{{asNum(zoyoTochiSu) + asNum(zoyoTatemonoSu) + asNum(zoyoDousanSu)}}</td>
            <td>件</td>
            <td class="right"></td>
            <td class="right">{{zoyoHosyuGokei}}</td>
          </tr>
          <tr v-if="sonotaHosyuGokei > 0">
            <td>給与所得等加算報酬</td>
            <td class="right">{{sonotaGokeiKensu}}</td>
            <td>件</td>
            <td class="right"></td>
            <td class="right">{{sonotaHosyuGokei}}</td>
          </tr>
          <tr v-for="_ in Array(6)">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="mitsumori-kei" colspan="4">小計</td>
            <td class="right">{{mitsumoriSyokei.toLocaleString()}}</td>
          </tr>
          <tr>
            <td class="mitsumori-kei" colspan="4">消費税</td>
            <td class="right">{{mitsumoriZei.toLocaleString()}}</td>
          </tr>
          <tr>
            <td class="mitsumori-kei" colspan="4">合計</td>
            <td class="right">{{mitsumoriGokei.toLocaleString()}}</td>
          </tr>
        </table>
        <md-button id="mitsumori-print-button" class="mitsumori-button md-raised" v-show="isShowing"
                   @click="print">
          印刷
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
  function asNum(str) {
    return Number(str.replace(/,/g, ''))
  }

  export default {
    name : 'Mitsumori',
    components : {},
    data() {
      return {
        zigyoSyotokuKbn : '無',
        zigyoShinkokuKbn : '白色申告',
        zigyoZenUri : '',
        zigyoZenZenUri : '',

        fudoSyotokuKbn : '無',
        fudoShinkokuKbn : '白色申告',
        fudoUriage : '',
        fudokojomaeSyotoku : '',
        fudoKyoyuSya : '無',
        fudoKyoyuSyaSu : '',

        kyuyoSyotokuKbn : '無',

        zatsuSyotokuKbn : '無',

        jotoSyotokuKbn : '無',
        jotoTochiSu : '',
        jotoTochiKbn : '購入時の領収証等有り',
        jotoTatemonoSu : '',
        jotoTatemonoKbn : '購入時の領収証等有り',
        jotoDousanSu : '',

        sonotaSyotokuKbn : '無',

        zassonkojo : '無',
        iryouhikojo : '無',
        syokiboKyosaikojo : '無',
        kifukinkojo : '無',
        kahukojo : '無',
        haigusyakojo : '無',

        jutakuLoankojo : '無',
        kabuSonkojo : '無',

        zoyoKeitai : '無',
        zoyoTochiSu : '',
        zoyoTochiHyoka : '倍率評価',
        zoyoTatemonoSu : '',
        zoyoDousanSu : '',
        zoyoTokurei : '無',

        isShowing : false
      }
    },
    computed : {
      mitsumoriNaiyou2_1 : function () {
        if (this.zigyoSyotokuKbn === '営業等') {
          return '事業所得'
        } else if (this.zigyoSyotokuKbn === '農業') {
          return '農業所得'
        } else if (this.fudoSyotokuKbn === '一括借上不動産' || this.fudoSyotokuKbn === '自己管理不動産') {
          return '不動産所得'
        } else {
          return '加算報酬'
        }
      },
      mitsumoriNaiyou2_2 : function () {
        if (this.zigyoHosyuGokei > 0 && this.fudoHosyuGokei > 0) {
          return '\t不動産所得'
        } else {
          return ''
        }
      },
      mitsumoriSuryo2 : function () {
        var suryo = 0
        if (this.mitsumoriNaiyou2_1 === '事業所得' || this.mitsumoriNaiyou2_1 === '農業所得' || this.mitsumoriNaiyou2_1 === '不動産所得') {
          suryo += this.zigyoHosyuGokei > 0 ? 1 : 0
          suryo += this.fudoHosyuGokei > 0 ? 1 : 0
        } else {
          suryo = 1
        }
        return suryo
      },
      mitsumoriKingaku2 : function () {
        if (this.mitsumoriNaiyou2_1 === '加算報酬') {
          return this.sonotaHosyuGokei
        } else {
          return this.zigyoHosyuGokei + this.fudoHosyuGokei - this.zigyoKihonHosyu
        }
      },
      mitsumoriNaiyou3 : function () {
        return this.jotoOption !== '' ? '譲渡所得<br><span class="mitsumori-syo-small-text">調査手数料として、表記以外に差額税金の１０％を頂きます。</span>' : '譲渡所得'
      },
      // AE157
      sonotaGokeiKensu : function () {
        var gokeiKensu = 0
        if (this.kyuyoSyotokuKbn !== '無') {
          gokeiKensu += 1
        }
        if (this.zatsuSyotokuKbn !== '無') {
          gokeiKensu += 1
        }
        if (this.sonotaSyotokuKbn !== '無') {
          gokeiKensu += 1
        }
        return gokeiKensu
      },
      // 見積書小計
      mitsumoriSyokei : function () {
        var syokei = 0
        syokei += this.zigyoSyotokuKbn === '無' && this.fudoSyotokuKbn === '無' ? 10000 : this.zigyoKihonHosyu
        syokei += this.mitsumoriKingaku2
        syokei += this.jotoSyotokuKbn === '有' ? this.jotoHosyuGokei + this.sonotaHosyuGokei : 0
        syokei += this.kojoHosyuGokei
        syokei += this.zoyoKeitai !== '無' ? this.zoyoHosyuGokei : 0
        syokei += this.sonotaHosyuGokei
        return syokei
      },
      // 見積書小計
      mitsumoriZei : function () {
        return this.mitsumoriSyokei * 0.08
      },
      // 見積書小計
      mitsumoriGokei : function () {
        return this.mitsumoriSyokei + this.mitsumoriZei
      },
      // J133
      zigyoSyotokuHeikin : function () {
        if (this.zigyoSyotokuKbn === '無') {
          return 0
        }
        return (asNum(this.zigyoZenUri) + asNum(this.zigyoZenZenUri)) / 2
      },
      // J134
      fudoUriageGokei : function () {
        if (this.fudoSyotokuKbn === '無') {
          return 0
        }
        return asNum(this.fudoUriage)
      },
      // J135
      fudoSyotokuGokei : function () {
        if (this.fudoSyotokuKbn === '無') {
          return 0
        }
        return asNum(this.fudokojomaeSyotoku)
      },
      // R134
      mitsumoriFuka : function () {
        return mitsumoriFuka(this.zigyoSyotokuHeikin, this.fudoUriageGokei)
      },

      // G138
      zigyoKihonHosyu : function () {
        return zigyoKihonHosyu()
      },
      // G140
      zigyoUriageHiritsu : function () {
        return zigyoUriageHiritsu(this.zigyoSyotokuHeikin)
      },
      // G141
      zigyoAoiroShinkoku : function () {
        return zigyoAoiroShinkoku(this.zigyoShinkokuKbn, this.zigyoSyotokuHeikin)
      },
      // G142
      zigyoHosyuGokei : function () {
        return zigyoHosyuGokei(this.zigyoSyotokuHeikin, this.zigyoUriageHiritsu, this.zigyoAoiroShinkoku)
      },

      // G147
      fudoUriageHiritsu : function () {
        return fudoUriageHiritsu(this.fudoUriageGokei)
      },
      // G148
      fudoSyotokuHiritsu : function () {
        return fudoSyotokuHiritsu(this.fudoSyotokuGokei)
      },
      // G150
      fudoAoiroShinkoku : function () {
        return fudoAoiroShinkoku(this.fudoShinkokuKbn, this.fudoUriageGokei)
      },
      // G151
      fudoHosyuSyokei : function () {
        return fudoHosyuSyokei(this.fudoUriageHiritsu, this.fudoSyotokuHiritsu, this.fudoAoiroShinkoku)
      },
      // G152
      fudoKyoyu : function () {
        return fudoKyoyu(this.fudoHosyuSyokei, this.fudoKyoyuSya, asNum(this.fudoKyoyuSyaSu))
      },
      // G153
      fudoHosyuGokei : function () {
        return fudoHosyuGokei(this.fudoUriageGokei, this.fudoHosyuSyokei, this.fudoKyoyu)
      },

      // G156
      sonotaKihonHosyu : function () {
        return sonotaKihonHosyu(this.kyuyoSyotokuKbn, this.zatsuSyotokuKbn, this.sonotaSyotokuKbn, this.zigyoHosyuGokei, this.fudoHosyuGokei)
      },
      // G157
      sonotaKasanHosyu : function () {
        return sonotaKasanHosyu(this.kyuyoSyotokuKbn, this.zatsuSyotokuKbn, this.sonotaSyotokuKbn)
      },
      // G158
      sonotaHosyuGokei : function () {
        return sonotaHosyuGokei(this.zigyoHosyuGokei, this.fudoHosyuGokei, this.sonotaKihonHosyu, this.sonotaKasanHosyu)
      },

      // G162
      jotoKihonHosyu : function () {
        return jotoKihonHosyu(this.zigyoHosyuGokei, this.fudoHosyuGokei, this.sonotaHosyuGokei)
      },
      // G163
      jotoKasanHosyu : function () {
        return jotoKasanHosyu(asNum(this.jotoTochiSu), asNum(this.jotoTatemonoSu), asNum(this.jotoDousanSu))
      },
      // G164
      jotoHosyuGokei : function () {
        return jotoHosyuGokei(this.jotoSyotokuKbn, this.jotoKihonHosyu, this.jotoKasanHosyu)
      },
      // G165
      jotoOption : function () {
        if (this.jotoTochiKbn === 'オプション調査' || this.jotoTatemonoKbn === 'オプション調査') {
          return 'オプション調査'
        } else {
          return ''
        }
      },

      // G169
      syotokukojoHosyu : function () {
        return syotokukojoHosyu(this.zassonkojo, this.iryouhikojo, this.syokiboKyosaikojo, this.kifukinkojo, this.kahukojo, this.haigusyakojo)
      },
      // G170
      kyuyoSyotokuTouAri : function () {
        return kyuyoSyotokuTouAri(this.syotokukojoHosyu)
      },
      // G171
      jutakuLoankojoHousyu : function () {
        return jutakuLoankojoHousyu(this.jutakuLoankojo)
      },
      // G172
      zeigakukojoHousyu : function () {
        return zeigakukojoHousyu(this.kabuSonkojo)
      },
      // G173
      kihonHosyuAri : function () {
        return kihonHosyuAri(this.syotokukojoHosyu, this.kyuyoSyotokuTouAri)
      },
      // G174
      kojoHosyuGokei : function () {
        return kojoHosyuGokei(this.syotokukojoHosyu, this.kyuyoSyotokuTouAri, this.jutakuLoankojoHousyu, this.zeigakukojoHousyu, this.kihonHosyuAri)
      },

      // G178
      zoyoKihonHosyu : function () {
        return zoyoKihonHosyu(this.zoyoKeitai)
      },
      // G179
      zoyoKasanHosyu : function () {
        return zoyoKasanHosyu(asNum(this.zoyoTochiSu), asNum(this.zoyoTatemonoSu), asNum(this.zoyoDousanSu))
      },
      // G180
      zoyoHyokaHosyu : function () {
        return zoyoHyokaHosyu(this.zoyoTochiHyoka, asNum(this.zoyoTochiSu))
      },
      // G181
      zoyoHosyuGokei : function () {
        return zoyoHosyuGokei(this.zoyoKihonHosyu, this.zoyoKasanHosyu, this.zoyoHyokaHosyu)
      },
    },
    methods : {
      asNum : function (str) {
        return Number(str.replace(/,/g, ''))
      },
      validateNumber : function (event) {
        if (event.inputType === 'insertCompositionText') {
          return
        }

        // 全角 → 半角、数値以外を除外
        event.target.value = event.target.value.replace(/[０-９]/g, function (s) {return String.fromCharCode(s.charCodeAt(0) - 65248)}).replace(/[^0-9]/g, '')
      },
      manageComma : function (key, hasFocus) {
        // コンマ追加、削除
        if (hasFocus) {
          // this[key] = this[key].replace(/,/g, '')
        } else {
          this[key] = this[key] ? Number(this[key].replace(/[^0-9]/g, '').replace(/,/g, '')).toLocaleString() : this[key]
        }
      },
      toggleShow : function () {
        this.isShowing = !this.isShowing

        if (this.isShowing) {
          // 見積書までスクロール
          setTimeout(function () {
            var y = document.getElementById('mitsumori-syo-wrapper')
              .getBoundingClientRect().top + window.scrollY - 32
            window.scroll({top : y, behavior : 'smooth'})
          }, 100)
        }
      },
      print : function () {
        var el = '#mitsumori-syo-wrapper'
        var iframe = document.createElement('IFRAME')
        var doc = null
        $(iframe).attr('style', 'position:absolute;width:0px;height:0px;left:-500px;top:-500px;')
        // $(iframe).attr('style', 'position:absolute;width:1000px;height:500px;left:0px;top:0px;')
        document.body.appendChild(iframe)
        doc = iframe.contentWindow.document
        doc.write('<div class="' + $(el).attr('class') + '">' + $(el).html() + '</div>')
        $('body', doc)[0].style.webkitPrintColorAdjust = 'exact'
        $('body', doc)[0].style.colorAdjust = 'exact'

        $('#mitsumori-print-button', doc).remove()

        // Styleをコピー
        var parentStyleSheets = document.styleSheets
        var cssString = ''
        for (var i = 0; i < parentStyleSheets.length; i++) {
          if (parentStyleSheets[i].cssRules) {
            var cssRules = parentStyleSheets[i].cssRules
            for (var j = 0; j < cssRules.length; j++)
              cssString += cssRules[j].cssText
          } else {
            cssString += parentStyleSheets[i].cssText
          }
        }
        var style = doc.createElement('style')
        style.type = 'text/css'
        style.innerHTML = cssString
        doc.getElementsByTagName('head')[0].appendChild(style)

        doc.close()
        iframe.contentWindow.focus()
        setTimeout(function () {
          iframe.contentWindow.print()
          setTimeout(function () {
            document.body.removeChild(iframe)
          }, 100)
        }, 100)
      }
    }
  }
</script>


<style scoped>
  input[type=text] {
    font-size : 16px;
  }

  #kakutei-wrapper {
    color            : #0B0B61;
    display          : flex;
    flex-flow        : column;
    align-items      : center;
    justify-content  : center;
    width            : 60%;
    margin           : auto;
    background-color : white;
    border-radius    : 4px;
    box-shadow       : 1px 1px 4px gray;
  }

  @media screen and (max-width : 1024px) {
    #kakutei-wrapper {
      width : 90%;
    }
  }

  .title {
    margin        : 32px 0;
    padding       : 8px 48px;
    border-bottom : 1px #D4E6FF solid;
  }

  .label-style {
    font-size : 12px;
    color     : rgba(0, 0, 0, 0.54);
  }

  .half-style {
    width     : 50%;
    max-width : 50%;
  }

  .sub-content {
    margin-left : 4%;
    width       : 46%;
  }

  @media screen and (max-width : 1024px) {
    .title {
      padding : 8px 16px;
    }

    .half-style {
      width     : 80%;
      max-width : 80%;
    }

    .sub-content {
      margin-left : 8%;
      width       : 72%;
    }
  }

  .unit {
    padding : 6px;
  }

  .right {
    text-align : right !important;
  }

  .left {
    text-align : left !important;
  }

  .center {
    text-align : center !important;
  }

  .warn-text {
    color : red;
  }

  #shiharai-sogaku {
    width            : 50%;
    font-size        : 36px;
    line-height      : 36px;
    padding          : 12px 24px 8px 24px;
    border-top       : 1px #0B0B61 solid;
    border-bottom    : 1px #0B0B61 solid;
    background-color : #EAF2FF;
  }

  @media screen and (max-width : 1024px) {
    #shiharai-sogaku {
      width : 90%;
    }
  }

  .mid-text {
    font-size : 24px;
  }

  .small-text {
    font-size : 16px;
  }

  .mitsumori-button {
    margin    : 24px 32px;
    font-size : 16px;
  }

  #mitsumori-syo-wrapper {
    margin-top : 32px;
    width      : 90%;
    overflow-x : auto;
  }

  #mitsumori-syo {
    min-width : 600px;
  }

  #mitsumori-title {
    width          : 100%;
    font-size      : 32px;
    line-height    : 32px;
    letter-spacing : 2em;
    padding-left   : 2em;
    margin-bottom  : 32px;
  }

  #mitsumori-client-wrapper {
    width      : 100%;
    text-align : left;
  }

  #mitsumori-client {
    width         : fit-content;
    border-bottom : 1px #0B0B61 solid;
  }

  #mitsumori-name {
    display    : inline-block;
    text-align : center;
    width      : 160px;
  }

  #mitsumori-sama {
    display    : inline-block;
    text-align : center;
    width      : 32px;
  }

  #mitsumori-contact-wrapper {
    width : 100%;
  }

  #mitsumori-contact {
    width      : fit-content;
    text-align : left;
    float      : right;
  }

  #mitsumori-cost-wrapeer {
    margin     : 48px 0 32px 0;
    width      : 100%;
    text-align : left;
  }

  #mitsumori-cost-table {
    width  : fit-content;
    border : 2px #0B0B61 solid;
  }

  #mitsumori-cost-title {
    padding      : 0 16px;
    font-weight  : bold;
    border-right : 2px #0B0B61 solid;
  }

  #mitsumori-cost {
    padding-left : 32px;
  }

  #mitsumori-table {
    width         : 100%;
    border        : 2px #0B0B61 solid;
    margin-bottom : 32px;
  }

  #mitsumori-table th {
    border              : 1px solid #0B0B61;
    border-bottom-width : 2px;
  }

  #mitsumori-table tr:nth-child(2n+1) {
    background : #F2FCFF;
  }

  #mitsumori-table tr:nth-child(1) {
    background : #EAF2FF;
  }

  #mitsumori-table tr:nth-last-child(1) {
    background : #EAF2FF;
  }

  #mitsumori-table td {
    border     : 1px #0B0B61 solid;
    padding    : 4px;
    text-align : left;
    height     : 30px;
  }

  .mitsumori-kei {
    font-weight   : bold;
    text-align    : right !important;
    padding-right : 32px !important;
  }
</style>

<style>
  .md-select-content {
    width : 30% !important;
  }

  .mitsumori-syo-small-text {
    font-size : 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Kakutei.vue